import { queryKeys } from '@query/keys'
import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'

import { useApiClient } from '@utils/ApiClient'
import { ClientApiClient } from '@utils/clientApi'

import type { DxtradeWatchlistsQuery, WatchlistModel } from '@model/DxTrade.types'

export const useDxtradeWatchlists = (query?: DxtradeWatchlistsQuery) => {
  const apiClient = useApiClient(ClientApiClient)

  const { data, isLoading } = useQuery<WatchlistModel[]>({
    queryKey: queryKeys.trade.dxtrade.watchlists(query),
    queryFn: () => apiClient.getDxtradeWatchlists(query),
  })

  const privateWatchlists = useMemo(() => data?.filter((w) => w.type === 'PRIVATE') ?? [], [data])

  return {
    watchlists: data,
    privateWatchlists,
    isLoading,
  }
}
